import { useNavigate } from "react-router-dom";
import { vehicleTypeSchema } from "../../Schema/generalSchema";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "react-query";
import { addVehicleType } from "../../Services/VehicleType";
import { Error, Success } from "../../Components/Modal";
import BackButton from "../../Components/BackButton";
import { useState } from "react";
import VehicleTypeForm from "./Components/VehicleTypeForm";
import "../CMSManagement/CMSManagement.css";
import "../../styles/PremiumCardPages.css";

export default function AddVehicleType() {
    const navigate = useNavigate();
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);

    const formMethods = useForm({
        resolver: yupResolver(vehicleTypeSchema),
        defaultValues: {
            status: "true",
            isHelperRequired: false,
            helperCount: 0,
        },
    });

    const { register, handleSubmit, formState: { errors }, control, watch, setValue } = formMethods;

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const { mutate, isLoading: loadingStatus } = useMutation(
        (data) => addVehicleType(data),
        {
            onSuccess: (res) => {
                Success("Vehicle Type", res.data?.message);
                navigate("/vehicle-type-management");
            },
            onError: (err) => {
                Error(err?.response?.data?.message);
            },
        }
    );

    const submit = (data) => {
        const formData = new FormData();
        formData.append("name", data?.name);
        formData.append("baseFare", data?.cost);
        formData.append("weight", data?.weightLimit);
        formData.append("active", data?.status);
        formData.append("helperCount", data?.isHelperRequired ? data?.helperCount : 0);
        formData.append("isHelperRequired", data?.isHelperRequired);
        formData.append("typeName", "vehicleImage");
        if (image) formData.append("vehicleImage", image);
        mutate(formData);
    };

    return (
        <div className="app-content content pform-page">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="add-vehicle-type">
                        <div className="user-details-wrapper">
                            <div className="pform-page-header">
                                <div className="pform-page-header__row">
                                    <BackButton />
                                    <h1 className="pform-page-header__title">Add New Vehicle Type</h1>
                                </div>
                                <p className="pform-page-header__subtitle">
                                    Configure vehicle pricing, capacity, and helper labor options
                                </p>
                            </div>

                            <div className="pform-shell pform-shell--wide">
                                <VehicleTypeForm
                                    register={register}
                                    handleSubmit={handleSubmit}
                                    errors={errors}
                                    control={control}
                                    onSubmit={submit}
                                    isLoading={loadingStatus}
                                    preview={preview}
                                    handleImageChange={handleImageChange}
                                    isHelperRequired={watch("isHelperRequired")}
                                    helperCount={watch("helperCount")}
                                    setValue={setValue}
                                    watch={watch}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
